import Vue from 'vue'
import SettingApi from '@/api/setting'
import UserApi from '@/api/user'
import camelCase from 'lodash/camelCase'
import isArray from 'lodash/isArray'
import VisitorApi from '@/api/visitor'
import CommonApi from '@/api/common'
import AreaApi from '@/api/area'
import AuditApi from '@/api/audit'
const setting = {
	namespaced: true,
	state: {
		INITPWD: '',
		companyTree: [],
		partnerTree: [],
		areas: [],
		partnerAndCompanyTree: [],
		orderStatusList: [],
		orderStatusMap: {},
		sexMap: {},
		sexList: [],
		idTypeMap: {},
		idTypeList: [],
		censusRegisterTypeMap: {},
		censusRegisterTypeList: [],
		treatmentMap: {},
		referralWaysMap: {},
		treatWaysMap: {},
		mentalStatusMap: {},
		trafficSituationMap: {},
		trafficSituationList: [],
		isPeccancyMap: {},
		isPeccancyList: [],
		caregiversIdentityMap: {},
		caregiversIdentityList: [],
		relationshipMap: {},
		taskLabelList: [],
		mediaTypeList: [],
		wageTypeMap: {},
		wageTypeList: [],
		injuryIdentityMap: {},
		injuryIdentityList: [],
		injuryPositionMap: {},
		injuryPositionList: [],
		spentPredictTypeMap: {},
		injuredTasktypeMap: {},
		injuredTasktypeList: [],
		independentMap: {},
		workStatusMap: {},
		incomePredictTypeMap: {},
		injuredSignatureMap: {},
		locorderStatusMap: {},
		locorderStatusList: [],
		revisitTaskStatusMap: {},
		revisitTaskStatusList: [],
		revisitOptStatusMap: {},
		revisitOptStatusList: [],
		yesNoMap: {},
		yesNoList: [],
		checkTypeMap: {},
		checkTypeList: [],
		checkStatusMap: {},
		checkStatusList: [],
		operationStatusMap: {},
		operationStatusList: [],
		insuranceTypeMap: {},
		insuranceTypeList: [],
		subinsuranceTypeMap: {},
		subinsuranceTypeList: [],
		activityPositionMap: {},
		activityPositionList: [],
		injuredLocationMap: {},
		injuredLocationList: [],
		carTypeMap: {},
		houseNatureMap: {},
		houseNatureList: [],
		relationTypeMap: {},
		houseTypeMap: {},
		companyTypeMap: {},
		contractTypeMap: {},
		leaveTypeMap: {},
		landlordTypeMap: {},
		committeeTypeMap: {},
		cancelTypeMap: {},
		medicalTypeMap: {},
		conciliationTasktypeMap: {},
		conciliationTasktypeList: [],
		invoiceTasktypeMap: {},
		invoiceTasktypeList: [],
		conOrderStatusMap: {},
		conOrderStatusList: [],
		conOperationStatusMap: {},
		conOperationStatusList: [],
		invoiceTaskStatusMap: {},
		invoiceTaskStatusList: [],
		surveryTasktypeMap: {},
		surveryTasktypeList: [],
		dependentTypeMap: {},
		dependentTypeList: [],
		emergencyTypeMap: {},
		emergencyTypeList: [],
		partnerStatusMap: {},
		dealStatusMap: {},
		dealStatusList: [],
		insuranceFornTypeMap: {},
		insuranceFornTypeList: [],
		readPaperMap: {},
		readPaperList: [],
		carPropertyMap: {},
		carPropertyList: [],
		involveDeathMap: {},
		involveDeathList: [],
		agentTypeMap: {},
		agentTypeList: [],
		fornTypeMap: {},
		fornTypeList: [],
		lawsuiTtypeMap: {},
		lawsuiTtypeList: [],
		lawsuitTasktypeMap: {},
		lawsuitTasktypeList: [],
		lawOrderStatusMap: {},
		lawOrderStatusList: [],
		injuredRelationMap: {},
		injuredRelationList: [],
		driverFeatureMap: {},
		accidentFeatureMap: {},
		examStatusList: [],
		examStatusMap: {},
		examTypeMap: {},
		examResultMap: {},
		exceptionTypeList: [],
		exceptionTypeMap: {},
		operationLogMap: {},
		einvoiceTasktypeList: [],
		einvoiceTasktypeMap: {},
		manualConfigTypeList: [],
		subTasktypeMap: {},
		subTasktypeList: [],
		orderTypeMap: {},
		orderTypeList: [],
		revisitTypeMap: {},
		revisitTypeList: [],
		ruleGenTimeList: [],
		ruleSymbolList: [],
		caseStatusList: [],
		caseStatusMap: {},
		endTypeMap: {},
		endTypeList: [],
		injuredSiteMap: {},
		injuredSiteList: [],
		surgeryMaterialMap: {},
		surgeryMaterialList: [],
		equipmentFixationMap: {},
		equipmentFixationList: [],
		jointReplacementMap: {},
		jointReplacementList: [],
		exerciseTypeMap: {},
		exerciseTypeList: [],
		disabilityLevelMap: {},
		disabilityLevelList: [],
		blameTypeMap: {},
		blameTypeList: [],
		otherRequireMap: {},
		otherRequireList: [],
		agentRelationMap: {},
		agentRelationList: [],
		icuStatusList: [],
		ruleBaseTypeList: [],
		cancelReasonTypeList: [],
		questionTypeMap: {
			0: '填空',
			1: '单选',
			2: '多选',
		},
		questionTypeList: [
			{
				value: '填空',
				key: '0',
			},
			{
				value: '单选',
				key: '1',
			},
			{
				value: '多选',
				key: '2',
			},
		],
		outHospitalList: [
			{
				value: '是',
				key: '1',
			},
			{
				value: '否',
				key: '0',
			},
			{
				value: '不清楚',
				key: '2',
			},
		],
		outHospitalMap: {
			0: '否',
			1: '是',
			2: '不清楚',
		},
		initiatorMap: {
			0: '保司',
			2: '作业人员',
		},
		accountStatusMap: {
			1: '启用',
			0: '停用',
		},
		accountStatusList: [
			{
				key: 1,
				value: '启用',
			},
			{
				key: 0,
				value: '停用',
			},
		],
		hasOrNotMap: {
			1: '有',
			0: '无',
		},
		hasOrNotList: [
			{
				key: '1',
				value: '有',
			},
			{
				key: '0',
				value: '无',
			},
		],
		selfDiseaseMap: {},
		selfDiseaseList: [],
		haveNoneMap: {},
		haveNoneList: [],
		accidentaffectMap: {},
		accidentaffectList: [],
		curetypeMap: {},
		curetypeList: [],
		fracturetypeMap: {},
		certiFiCatetypeList: [],
		certiFiCatetypeMap: {},
		beneficiarytypeList: [],
		beneficiarytypeMap: {},
		fracturetypeList: [],
		primarysiteMap: {},
		primarysiteList: [],
		paicIndustryList: [],
		paicIndustryMap: {},
		paicHospitalsubjectList: [],
		paicHospitalsubjectMap: {},
		lockedMap: {
			true: '是',
			false: '否',
		},
		lockedList: [
			{
				key: true,
				value: '是',
			},
			{
				key: false,
				value: '否',
			},
		],
		educationList: [],
		educationMap: {},
		politicsList: [],
		politicsMap: {},
		careerList: [],
		careerMap: {},
		einsTypeList: [],
		einsTypeMap: {},
		settleStatusList: [],
		settleStatusMap: {},
	},
	mutations: {
		SET_INITPWD: (state: any, value: string) => {
			state.INITPWD = value
		},
		SET_STATE(state: any, obj: any) {
			state[obj.key] = obj.value
		},
		SET_SETTING(state: any, obj: any) {
			state[camelCase(obj.key) + obj.type] = obj.value
		},
	},
	actions: {
		setINITPWD(store: any, value: string) {
			SettingApi.getSetting('INITPWD').then((res: any) => {
				store.commit('SET_INITPWD', res.data)
			})
		},
		setSettings(store: any, params: any[]) {
			let reqList: any = []
			const reqMap: any = {}
			params.forEach((item: any) => {
				reqList = reqList.concat(item.list)
				item.list.forEach((i: any) => {
					reqMap[i] = isArray(item.type) ? item.type : [item.type]
				})
			})
			reqList = reqList.map((item: any) => item.trim())
			return SettingApi.getSettingLists(reqList).then((res: any) => {
				for (const dic in res.data) {
					reqMap[dic].forEach((i: any) => {
						if (i === 'List') {
							store.commit('SET_SETTING', {
								key: dic,
								type: i,
								value: res.data[dic]
									.filter((i: any) => i.delFlag === '0')
									.reduce((arr: any, value: any) => {
										arr.push({
											key: value.dicKey,
											value: value.dicValue,
										})
										return arr
									}, []),
							})
						} else if (i === 'Map') {
							store.commit('SET_SETTING', {
								key: dic,
								type: i,
								value: res.data[dic].reduce((obj: any, value: any) => {
									obj[value.dicKey] = value.dicValue
									return obj
								}, {}),
							})
						}
					})
				}
			})
		},
		async getDicPAIC(store: any) {
			// 平安定制相关字典值
			const res = await AuditApi.getIndustryList({ keyword: '' })

			function listDictProcess(data: any, type: any) {
				switch (type) {
					case 'List':
						return data.map((item: any) => {
							return {
								key: item.dicKey,
								code: item.dicKey,
								value: item.dicValue,
								name: item.dicValue,
							}
						})
					case 'Map':
						return data.reduce((obj: any, item: any) => {
							obj[item.dicKey] = item.dicValue
							return obj
						}, {})
				}
				return []
			}

			const data = res.data || []
			const listData = listDictProcess(data, 'List')
			const mapData = listDictProcess(data, 'Map')
			store.commit('SET_SETTING', {
				key: 'paicIndustry',
				type: 'List',
				value: listData,
			})
			store.commit('SET_SETTING', {
				key: 'paicIndustry',
				type: 'Map',
				value: mapData,
			})
		},
		initCompanyTree(store: any) {
			if (store.state.companyTree.length) {
				return
			}
			return UserApi.getCompanies().then((res: any) => {
				store.commit('SET_STATE', {
					key: 'companyTree',
					value: res.data.reduce((list: any, value: any) => {
						list.push({
							value: value.companyId + '',
							key: value.companyId,
							title: value.companyName,
							isLeaf: value.leaf,
						})
						return list
					}, []),
				})
			})
		},
		loadCompanyTree(store: any, treeNode: any): Promise<void> {
			return new Promise(resolve => {
				if (treeNode.dataRef.children) {
					// 有值了直接渲染
					resolve()
					return
				}
				UserApi.getCompanies(treeNode.dataRef.key).then((res: any) => {
					Vue.set(
						treeNode.dataRef,
						'children',
						res.data.reduce((list: any, value: any) => {
							list.push({
								value: value.companyId + '',
								key: value.companyId,
								title: value.companyName,
								isLeaf: value.leaf,
							})
							return list
						}, [])
					)
					resolve()
				})
			})
		},
		initPartnerTree(store: any) {
			if (store.state.partnerTree.length) {
				return
			}
			VisitorApi.getCompanies().then((res: any) => {
				store.commit('SET_STATE', {
					key: 'partnerTree',
					value: res.data.reduce((list: any, value: any) => {
						list.push({
							value: value.companyId + '',
							key: value.companyId,
							title: value.companyName,
							isLeaf: value.leaf,
						})
						return list
					}, []),
				})
			})
		},
		loadPartnerTree(store: any, treeNode: any): Promise<void> {
			return new Promise(resolve => {
				if (treeNode.dataRef.children) {
					// 有值了直接渲染
					resolve()
					return
				}
				VisitorApi.getCompanies(treeNode.dataRef.key).then((res: any) => {
					Vue.set(
						treeNode.dataRef,
						'children',
						res.data.reduce((list: any, value: any) => {
							list.push({
								value: value.companyId + '',
								key: value.companyId,
								title: value.companyName,
								isLeaf: value.leaf,
							})
							return list
						}, [])
					)
					resolve()
				})
			})
		},
		initPartnerAndCompany(store: any) {
			if (store.state.partnerAndCompanyTree.length) {
				return
			}
			return CommonApi.getPartnerAndCompany().then((res: any) => {
				store.commit('SET_STATE', {
					key: 'partnerAndCompanyTree',
					value: res.data.reduce((list: any, value: any) => {
						list.push({
							value: value.companyId + '',
							key: value.companyId,
							title: value.companyName,
							isLeaf: value.leaf,
						})
						return list
					}, []),
				})
			})
		},
		loadPartnerAndCompany(store: any, treeNode: any): Promise<void> {
			return new Promise(resolve => {
				if (treeNode.dataRef.children) {
					// 有值了直接渲染
					resolve()
					return
				}
				CommonApi.getPartnerAndCompany(treeNode.dataRef.key).then(
					(res: any) => {
						Vue.set(
							treeNode.dataRef,
							'children',
							res.data.reduce((list: any, value: any) => {
								list.push({
									value: value.companyId + '',
									key: value.companyId,
									title: value.companyName,
									isLeaf: value.leaf,
								})
								return list
							}, [])
						)
						resolve()
					}
				)
			})
		},
		initAreas(store: any) {
			if (store.state.areas.length) {
				return
			}
			AreaApi.getProvince().then((res: any) => {
				store.commit('SET_STATE', {
					key: 'areas',
					value: res.data.reduce((list: any, value: any) => {
						list.push({
							value: value.areaCode,
							key: value.areaCode,
							title: value.areaName,
							isLeaf: value.areaCode.slice(-2) !== '00',
						})
						return list
					}, []),
				})
			})
		},
		loadAreas(store: any, treeNode: any): Promise<void> {
			return new Promise(resolve => {
				if (treeNode.dataRef.children) {
					// 有值了直接渲染
					resolve()
					return
				}
				async function f() {
					const areaCode: any = treeNode.dataRef.key
					let res: any = ''
					if (areaCode.slice(2, 4) === '00') {
						res = await AreaApi.getCity(areaCode)
					} else {
						res = await AreaApi.getArea(areaCode)
					}
					Vue.set(
						treeNode.dataRef,
						'children',
						res.data.reduce((list: any, value: any) => {
							list.push({
								value: value.areaCode,
								key: value.areaCode,
								title: value.areaName,
								isLeaf: value.areaCode.slice(-2) !== '00',
							})
							return list
						}, [])
					)
					resolve()
				}
				f()
			})
		},
		loadManageAreas(store: any, payload: any): Promise<void> {
			let {
				treeNode,
				isCityLeaf,
				isAreaLeaf,
			}: { treeNode: any; isCityLeaf: boolean; isAreaLeaf: boolean } = payload
			return new Promise(resolve => {
				// if (treeNode.dataRef.children) {
				// 	// 有值了直接渲染
				// 	resolve()
				// 	return
				// }
				async function f() {
					const areaCode: any = treeNode.dataRef.key.split('-').pop()
					let res: any = '',
						isCurrentCity = false
					if (areaCode.slice(2, 4) === '00') {
						res = await AreaApi.getCity(areaCode)
						isCurrentCity = true
					} else {
						res = await AreaApi.getArea(areaCode)
						isCurrentCity = false
					}
					Vue.set(
						treeNode.dataRef,
						'children',
						res.data.reduce((list: any, value: any) => {
							list.push({
								value: `${treeNode.dataRef.key}-${value.areaCode}`,
								key: `${treeNode.dataRef.key}-${value.areaCode}`,
								title: value.areaName,
								isLeaf:
									isCurrentCity && isCityLeaf
										? true
										: value.areaCode.slice(-2) !== '00',
								disabled: isAreaLeaf && isCurrentCity ? true : false,
								fullDesc: `${treeNode.dataRef.fullDesc ||
									treeNode.dataRef.title}${value.areaName}`,
							})
							return list
						}, [])
					)
					resolve()
				}
				f()
			})
		},
	},
}

export default setting
